import { PageOptionsDto } from '@platri/elab-common-swagger';

export class GetMessagesByFilterRequestDto extends PageOptionsDto {
  pokemonId: number;
}
